import { round } from 'lodash-es'

export const roundPoints = (
  points: Point[],
  config: {
    roundX?: number
    roundY?: number
    roundZ?: number
  } = {},
) => {
  return points.map(point => ({
    x: config.roundX === undefined ? point.x : round(point.x, config.roundX),
    y: config.roundY === undefined ? point.y : round(point.y, config.roundY),
    z: config.roundZ === undefined ? point.z : round(point.z, config.roundZ),
  }))
}

export default roundPoints
